import { useNavigate } from 'react-router-dom'
import Card from '../../public/components/Card'
import EditableListPage from '../components/EditableListPage'
import { Button } from '../../shared/components/Button'
import { FaPen } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

const ProjectJourneysAdmin = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderCard = item => (
        <Card key={item.id} imageSrc={item.image_url} button={false}>
            <span className='inline-block px-3 py-1 mb-2 text-xs font-medium text-yellow-800 bg-yellow-200 rounded-full'>
                {item.project_name}
            </span>
            <h3>{item.title}</h3>
            <span className='text-sm text-gray-500'>{item.subtitle}</span>
            <p>{item.small_description}</p>
            <div className='flex items-center justify-between mt-4'>
                <Button
                    variant='secondary'
                    onClick={() => navigate(`/admin/auth/projects/${item.project_id}`)}
                >
                    {t('status.goto_project')}
                </Button>
                <Button
                    variant='primary'
                    onClick={() => navigate(`/admin/auth/project-journeys/${item.id}`)}
                >
                    {t('status.details')}
                </Button>
            </div>
        </Card>
    )

    return (
        <EditableListPage
            title={t('navigation_admin.projects.journeys')}
            endpoint='admin/project-journeys'
            renderCard={renderCard}
            buttons={
                <Button
                    size='medium'
                    onClick={() => navigate('/admin/auth/project-journeys/create')}
                >
                    <FaPen /> {t('status.create')}
                </Button>
            }
        />
    )
}

export default ProjectJourneysAdmin
